import React from 'react';
import { buttonStyle, sectionHeaderStyle } from './styles';

interface DebugTogglesProps {
  onAction: (action: string, data?: any) => void;
}

export const DebugToggles: React.FC<DebugTogglesProps> = ({ onAction }) => {
  return (
    <>
      <div style={sectionHeaderStyle}>Debug</div>
      <button style={buttonStyle} onClick={() => onAction('toggle_hitboxes')}>📦 Show Hitboxes</button>
      <button style={buttonStyle} onClick={() => onAction('toggle_velocity')}>➡️ Show Velocity Vectors</button>
      <button style={buttonStyle} onClick={() => onAction('toggle_physics_state')}>🦶 Show Physics State</button>
      <button style={buttonStyle} onClick={() => onAction('toggle_collision_flash')}>💥 Flash on Collision</button>
      <button style={buttonStyle} onClick={() => onAction('toggle_aggro_range')}>🎯 Show Aggro Range</button>
      <button style={buttonStyle} onClick={() => onAction('toggle_melee_cone')}>🗡️ Show Melee Swing Cone</button>
      <button style={buttonStyle} onClick={() => onAction('toggle_ui')}>👁️ Toggle UI</button>
      <button style={buttonStyle} onClick={() => onAction('toggle_ability_check')}>🎯 Target Ability Check</button>
      <button style={buttonStyle} onClick={() => onAction('toggle_lifecycle_monitor')}>📊 Ability Lifecycle</button>
      <button style={buttonStyle} onClick={() => onAction('toggle_visual_lifecycle')}>🎨 Visual Lifecycle</button>
      <button style={buttonStyle} onClick={() => onAction('toggle_target_lifecycle')}>🎯 Target Lifecycle</button>
      <button style={buttonStyle} onClick={() => onAction('toggle_test_rig')}>🧪 Ability Test Rig</button>
      <button style={buttonStyle} onClick={() => onAction('toggle_netobs_packet_log')}>📡 Netobs Packet Log</button>
      <button style={buttonStyle} onClick={() => onAction('toggle_netobs_latency_heatmap')}>🌡️ Netobs Latency Heatmap</button>
      <button style={buttonStyle} onClick={() => {
        // Open the netobs popout in a new window (~Chrome DevTools
        // "undock to separate window" pattern). Same origin → can use
        // BroadcastChannel; popout subscribes for live data.
        // ?netobs=1 alongside ?popout=1 so UIContext auto-opens the
        // PacketLog + LatencyHeatmap panels in the child window.
        const url = `/?popout=1&netobs=1`;
        try {
          window.open(url, 'helix-netobs-popout', 'width=1100,height=720,resizable=yes,scrollbars=no');
        } catch { /* popup blocker */ }
      }}>🪟 Pop-out Netobs Window</button>
      <button style={buttonStyle} onClick={() => onAction('toggle_logger')}>📝 Toggle Logger</button>
    </>
  );
};
